<div class="inputs__container-load-file">
  <div class="load-file-upload" [ngClass]="{ 'is-upload-error': isUploadError }" *ngIf="stepUploadFile">
    <div class="upload-container">
      <div class="upload-box">
        <div class="upload-icon">
          <mat-icon class="face-scan-icon">ar_on_you</mat-icon>
        </div>
        <common-secondary-buttons-filled 
          class="face-register-button"
          [iconPosition]="false" 
          [label]="'usersModule.biometric.register' | translate" 
          [disabled]="false" 
          (output)="openRecognition()">
        </common-secondary-buttons-filled>
      </div>
    </div>
  </div>

  <div class="upload-container-error" *ngIf="isUploadError"></div>

  <div class="upload-progress-container" *ngIf="!stepUploadFile">
    <div class="upload-progress-container-border">
      <div class="photo-preview" *ngIf="previewUrl" (click)="openPhotoPreview()">
        <img [src]="previewUrl" alt="face preview" />
        <mat-icon class="expand-icon">open_in_full</mat-icon>
      </div>
      <div class="biometric-registration-grid">
        <div class="registration-date-row">
          <div class="c_500">
            {{ 'usersModule.biometric.registrationDate' | translate }}
          </div>
          <div class="registration-date-value s1_500">
            {{ registrationDate | date:'dd MMM yyyy - HH:mm a' }}
          </div>
        </div>
        <div class="update-button-row">
          <common-secondary-buttons-filled 
            class="update-button-full-width"
            [icon]="'https://munily-public-cdn.s3.us-east-1.amazonaws.com/shared/dashboard/mat_icons/perm_camera_mic.svg'" 
            [typeIcon]="'customized'" 
            [iconPosition]="false" 
            [label]="'buttons.update' | translate" 
            [disabled]="false" 
            (output)="openRecognition()">
          </common-secondary-buttons-filled>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #faceRecognitionModal let-c="close" let-d="dismiss">
  <shared-face-recognition-modal 
    (faceData)="onFaceData($event)" 
    (urlPhoto)="onFaceUrl($event)"
    (closeModal)="onCloseFaceModal()" 
    [formGuest]="formStub">
  </shared-face-recognition-modal>
</ng-template>


